import { useEffect } from 'react';
import { SessionProvider } from 'next-auth/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { AppProps } from 'next/app';
import type { Session } from 'next-auth';

import '../lib/tracing';
import '../assets/main.css';
import '../assets/chrome-bug.css';
import 'rc-slider/assets/index.css';

const queryClient = new QueryClient();

const SESSION_REFRESH_INTERVAL = 20 * 60; // 20 minutes

function CustomApp({
  Component,
  pageProps,
}: AppProps<{
  session: Session;
}>) {
  const Layout =
    (Component as any).Layout || (({ children }) => <>{children}</>);

  useEffect(() => {
    document.body.classList?.remove('loading');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider
        session={pageProps.session}
        refetchInterval={SESSION_REFRESH_INTERVAL}
      >
        <Layout pageProps={pageProps}>
          <Component {...pageProps} />
        </Layout>
        <Toaster />
      </SessionProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}

export default CustomApp;
